import React from "react";

export const SvgHiddenGem = () => {
	return (
		<svg
			width="16"
			height="14"
			viewBox="0 0 16 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.373 3.02421L15.9989 2.56L14.373 2.09579C14.1456 2.0311 13.9678 1.85332 13.9031 1.62586L13.4389 0L12.9747 1.62586C12.91 1.85332 12.7322 2.0311 12.5048 2.09579L10.8789 2.56L12.5048 3.02421C12.7322 3.0889 12.91 3.26668 12.9747 3.49414L13.4389 5.12L13.9031 3.49414C13.9678 3.26668 14.1456 3.0889 14.373 3.02421Z"
				fill="#0F00B2"
			/>
			<path
				d="M3.19995 3.75977C3.03023 3.75977 2.86749 3.82726 2.74749 3.94726L0.187413 6.50723C-0.0532283 6.74798 -0.0634071 7.13498 0.164271 7.38793L5.92427 13.7878C6.04566 13.9227 6.21858 13.9998 6.39999 13.9998C6.5814 13.9998 6.75431 13.9227 6.87571 13.7878L12.6357 7.38793C12.8634 7.13496 12.8532 6.74797 12.6126 6.50723L10.0525 3.94726C9.93249 3.82726 9.76973 3.75977 9.60003 3.75977H3.19995Z"
				fill="#0F00B2"
			/>
		</svg>
	);
};
